/*
 * Copyright (c) 2022. American Express Company
 */

// theirs
import React, { Component, ReactComponentElement } from 'react';
// ours
import { CardRounded, IconInfo } from '@americanexpress/dls-react';
import Anchor from '../atomic/atoms/anchor/Anchor';
import { InfoCardViewModel } from 'src/types/view-models/info-card-view.model';
// stylesheets
import styles from './InfoCard.module.scss';
import Typography from '../typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';

export default class InfoCard extends Component<InfoCardViewModel> {
    public override render(): ReactComponentElement<any> {
        return (
            <CardRounded className={this.getClasses()}>
                <div className={styles.cardInterior}>
                    <IconInfo className={styles.infoIcon} />
                    <div className={styles.infoColumnRight}>
                        <Typography variant={TypographyVariants.SUBTEXT_BOLD}>{this.props.title}</Typography>
                        <Anchor href={this.props.url} typographyProps={{ variant: TypographyVariants.SUBTEXT }}>
                            {this.props.subtitle}
                        </Anchor>
                    </div>
                </div>
            </CardRounded>
        );
    }

    // get CSS classes
    private getClasses(): string {
        const classes: string[] = [];

        if (this.props.className) {
            classes.push(this.props.className);
        }

        classes.push(styles.infoCard);

        return classes.join(' ');
    }
}
